import * as yup from 'yup';

export const medicalInsuredsValidationSchema = (lineCode: string) => {
  const isExpat = lineCode === '48';

  return yup.object({
    medicalInsureds: yup.array().of(
      yup.object().shape({
        insuredID: yup.string().required('Insured is required'),
        isPrincipal: yup.boolean(),
        personType: yup.string(),
        relation: yup.string().when('isPrincipal', {
          is: false,
          then: (schema) => schema.required('Relation is required'),
          otherwise: (schema) => schema.notRequired()
        }),
        addressID: yup.string().when('isPrincipal', {
          is: true,
          then: (schema) => schema.required('Insured Address is required'),
          otherwise: (schema) => schema.notRequired()
        }),
        addressDetails: yup.string(),
        cardNumber: yup.string(),
        dateOfBirth: yup.string().when(['isPrincipal', 'personType'], {
          is: (isPrincipal: boolean, personType: string) => {
            if (isPrincipal) {
              return personType === 'INDIVIDUAL';
            }

            return personType === 'INDIVIDUAL';
          },
          then: (schema) => schema.required('Date of Birth is required'),
          otherwise: (schema) => schema.notRequired()
        }),
        passportNumber: isExpat
          ? yup.string().when('personType', {
              is: (personType: string) => personType === 'INDIVIDUAL',
              then: (schema) => schema.required('Passport Number is required'),
              otherwise: (schema) => schema.notRequired()
            })
          : yup.string(),
        continuity: yup.string(),
        tpaReference1: yup.string(),
        tpaReference2: yup.string(),
        grApplicable: yup.string(),
        exclusions: yup.string(),
        remarks: yup.string(),
        isNew: yup.boolean(),
        isRemoved: yup.boolean(),
        sequence: yup.number()
      })
    )
  });
};
